import { isEmpty, memoize } from 'lodash';

export const getHostName = memoize((url: string) => {
  try {
    return new URL(url).hostname;
  } catch (e) {
    return 'Unknown Domain';
  }
});

export const getFormattedUrl = memoize((url: string): string => {
  let formattedUrl = url;
  if (url.indexOf('.') !== -1) {
    formattedUrl = url.indexOf('://') === -1 && url !== '' ? `https://${url}` : url;
  }

  return formattedUrl;
});

export const isValidUrl = memoize((_urlStr: string) => {
  const urlStr = getFormattedUrl(_urlStr);
  const res = urlStr.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  return !!(res !== null);
});

const containsHtmlTags = memoize((urlStr: string): boolean => {
  const res = urlStr.match(/<\/?[a-z][\s\S]*>/i);
  return !!(res !== null);
});

export const isAbsoluteOrRelativeUrlValid = (url: string): boolean => {
  return isEmpty(url) || !containsHtmlTags(url);
};

export const readSearchParam = (s: string) => {
  const search = new URLSearchParams(window.location.search);
  return search.get(s);
};
